import React from 'react'
import Colors from '../assets/Colors'
import Fonts from '../assets/Fonts'
import classes from './SavedFilters.module.css'

function SavedFilters({ data }) {
    return (
        <div className={classes.card} style={{ background: Colors.white }}>
            <p style={{ ...Fonts.otherSemiBold, color: Colors.neutralShadesOfDimGray }}>Saved Filters</p>
            <ul>
                {data?.map(item => <li style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}>{item}</li>)}
            </ul>
        </div>
    )
}

export { SavedFilters }